export default __webpack_public_path__ + "static/media/DinosaursFlyingRetiples_09.4ef481da.png";